export enum ContractType {
  GeenContract = 'geen_contract',
  Monitor = 'monitor_student',
  Vrijwilliger = 'vrijwilliger',
  Studentenjob = 'studentenjob',
  Bijklusser = 'bijklusser',
  MonitorNietStudent = 'monitor_niet_student',
}

export class ContractData {
  type!: ContractType;
  hourlyPay!: number;
}
